import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import SiteComplianceLayout from './components/SiteComplianceLayout';
import SiteComplianceRoutes from './routes';
import SuspenseFallback from '@/shared/ui/SuspenseFallback';

const SiteComplianceApp = () => (
  <Routes>
    <Route element={<SiteComplianceLayout />}>
      <Route
        path="/*"
        element={
          <Suspense fallback={<SuspenseFallback />}>
            <SiteComplianceRoutes />
          </Suspense>
        }
      />
    </Route>
  </Routes>
);

export default SiteComplianceApp;
